import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageUtil } from 'src/app/helpers/messages';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-view-individual-record',
  templateUrl: './view-individual-record.component.html',
  styleUrls: ['./view-individual-record.component.scss']
})
export class ViewIndividualRecordComponent implements OnInit {
  photoLoading: boolean;
  recordDetails: any;
  picPreview: any;
  photoError: boolean;

  constructor(public dialogRef: MatDialogRef<ViewIndividualRecordComponent>,
    private app: AppService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,

    ) { }

  ngOnInit(): void {
    this.getRecordDetails()

  }
  
  getRecordDetails(){
    this.photoLoading = true;
    this.app.recordService.getRecordDetails(this.app.helperService.getUserId(),"INDIVIDUAL",this.data.id)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
        this.recordDetails = res['data']
        this.picPreview = this.recordDetails.identification.photo
        this.photoLoading = false
        if(!this.recordDetails.identification.photo){
          this.picPreview = this.recordDetails.identification.photo
          this.photoError = true 
        }else{
          this.photoError = false

        }

  
        // this.snack.openSnackBar('Successfull', 'Close', 'Success', 'center','bottom')
    
        
      }
      else { 
        this.photoLoading = false
        this.photoError = true

        // this.snack.openSnackBar(res['data'], 'Close', 'Error', 'start')
      }
    }, err => {
      this.photoLoading = false
      this.photoError = true

      // this.snack.openSnackBar( MessageUtil.SAVE_NOT_DONE, 'Close', 'Error', 'start');
    }
    )
  }
  associateId(arg0: any, arg1: string, associateId: any) {
    throw new Error('Method not implemented.');
  }

  closeModal() {
    this.dialogRef.close('')
  }
  viewMore(){
    this.router.navigate(['app/records/view-individual/'+this.data.id])
        this.dialogRef.close('')
  }

}
